import script from "./InvoiceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSettings.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSettings.vue?vue&type=style&index=0&id=60460fe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60460fe4"]])

export default __exports__